<template>
  <div id="app">
    <vue-snotify></vue-snotify>
    <toast ref="toast"></toast>
    <navigation-component/>
    <div id="content">
        <div class="container">
        <div v-if="$route.name != 'login'" class="mission-statement"></div>

     <div class="beans" >
        <div style="width: 80px; position: absolute; top: 65px; left: 10px; z-index: 0" >
          <img src="@/assets/images/Bean-1.svg" />
        </div>     
        <div style="width: 126px; position: absolute; top: 248px; left: -87px; z-index: 0; transform: rotate(-40deg);" >
          <img src="@/assets/images/Bean-2.svg" />
        </div>
        <div style="width: 125px; position: absolute; top: -26px; right: 47px; z-index: 0" >
          <img src="@/assets/images/Bean-2.svg" />
        </div>
        <div style="width: 115px; position: absolute; top: 300px; right: -153px; z-index: 0" >
          <img src="@/assets/images/Bean-1.svg" />
        </div>
        <div style="width: 170px; position: absolute; top: 400px; right: -59px; z-index: 0" >
          <img src="@/assets/images/Bean-3.svg" />
        </div>
        <div style="width: 97px; position: absolute; top: 534px; right: -94px; z-index: 0" >
          <img src="@/assets/images/Bean-4.svg" />
        </div>
        </div>
      <template v-if="$route.matched.length">
        <div class="view" >
          <transition :name="transitionName" mode="out-in">
            <!--<keep-alive>-->
              <router-view class="child-view" :key="$route.fullPath"/>
            <!--</keep-alive>-->
          </transition>
        </div>
      </template>
      <div style="margin-top: 75px" v-else>
        <h1>Oops! Nothing here</h1>
        <p>Please try a different url</p>
      </div>
      </div>
    </div>
    <footer class="has-background-primary footer">
      <div class="container columns has-text-white " >
        <div class="column footerColumn " style="padding-left:0px;">
          <h2 class="footerHead"><a href="https://deansbeans.com/pages/contacts">Contact Us</a></h2>
          <p class="footerText"><a href="mailto:wholesale@deansbeans.com" class="footerLink">wholesale@deansbeans.com</a></p>
          <p class="footerText">978-544-2002</p>
          <p class="footerText">50 R.W. Moore Ave</p>
          <p class="footerText">Orange Massachusetts</p>
          <p class="footerText">01364 United States</p>
        </div>
        <div class="column footerColumn ">
          <h2 class="footerHead">Social</h2>
          <div class="footerSMGroup">
            <a href="https://www.facebook.com/DeansBeansOrganicFairTradeCoffee/" target="_blank" class="footerLink footerSM">
              <i class="icon icon--facebook"></i>
            </a>
            <a href="https://twitter.com/deans_beans" target="_blank" class="footerLink footerSM">
              <i class="icon icon--twitter"></i>
            </a>
            <a href="https://www.instagram.com/deansbeanscoffee/" target="_blank" class="footerLink footerSM">
              <i class="icon icon--instagram"></i>
            </a>
            <a href="https://www.youtube.com/user/javatrekker/" target="_blank" class="footerLink footerSM">
              <i class="icon icon--youtube"></i>
            </a>
          </div>
          <a href="https://deansbeans.com/" target="_blank" class="footerLink footerText">
            deansbeans.com
          </a>
        </div>
        <div class="column footerColumn">
          <a href="https://deansbeans.com/pages/certified-b-corporation" target="_blank" class="footerLink">
            <img class="footerLogo" src="@/assets/images/footer-certified-b-corporation.png">            
          </a>
          <a href="https://deansbeans.com/pages/organic-certificate" target="_blank" class="footerLink">
            <img class="footerLogo" src="@/assets/images/footer-usda-organic.png">            
          </a>
          <a href="https://deansbeans.com/pages/organic-certificate" target="_blank" class="footerLink">
            <img class="footerLogo" src="@/assets/images/footer-fair-trade.png">            
          </a>
          <a href="https://nationalzoo.si.edu/migratory-birds/bird-friendly" target="_blank" class="footerLink">
            <img class="footerLogo" src="@/assets/images/footer-bird-friendly.png">            
          </a>
        </div>

      </div>
      <div class="container">
        <p class="footerEnd">© 2022, Dean's Beans Organic Coffee Company</p>
      </div>
    </footer>
  </div>
</template>

<script>
import NavigationComponent from '@/components/Navigation'
import Toast from '@/components/Toast.vue'


export default {
  name: 'App',
  components: {
    'navigation-component': NavigationComponent,
    'toast': Toast
  },
  data () {
    return {
      transitionName: 'fade',
      pathEnumDict: {
        home: 0,
        contacts: 1,
        inquiries: 2,
        applicationGeneration: 3,
        other: 4,
        reports: 5,
        calendar: 6,
        users: 7,
        userInfo: 8,
        changePassword: 9 
      }
    }
  },
  computed: {
    currentYear: function(){
      return new Date().getFullYear()
    },
    route: function(){
      return this.$route;  
    },
    emailLink: function(){
      return "mailto:wholesale@deansbeans.com?"
    }
  },
  watch: {
    '$route' (to, from) {
      try{
        var toNum = this.pathEnumDict[to.name]
        var fromNum = this.pathEnumDict[from.name]
        
        // this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
        this.transitionName = toNum > fromNum ? 'slide-left' : 'slide-right'
      }
      catch(err){
        this.transitionName = 'slide-right'
      }
    }
  }
}
</script>

<style lang="scss">

// Import Bulma's core
@import "~bulma/sass/utilities/_all";
@import "~vue-snotify/styles/material";

// Set your colors
$primary: #56a26b;
$primary-invert: findColorInvert($primary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);
$danger: #E4241B;
// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
// @import "~bulma";
// @import "~buefy/src/scss/buefy";
@import './style.scss';

.subtableBackground{
  background-color: transparent; 
}
#content{
    margin-top: 6rem;
    position: relative;
    flex: 1 1 auto;
}

// .beans{
//     // height: 100%;
//     // width: 100%;
//     // position: relative;
//     // top:0;
// }
.view{
  margin-bottom: 54px;
  padding-top: 1rem;
  padding-bottom: 2rem;
  // height:90vh;
  background-color: #fff;
}
.container {
    padding: 0 30px;
    max-width: 1600px;
    width: 100%;
    margin: 0 auto;
}

body{
    color: #4a4a4a;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    background-color: #fff;
}
    .mission-statement{
        content: url(./assets/images/mission-statement-desktop.svg);
            max-width: 660px;
            margin: 0 auto;
            padding-top: 1rem;
    }

    #app{
        height: 100%;
        width:100%;
        display: flex;
        flex-direction: column;
        min-height: 100vh;
    }
@media only screen and (max-width: 1280px) {
    .beans{
      display: none;
    }
}
@media only screen and (max-width: 768px) {
    .mission-statement {
        content: url(./assets/images/mission-statement-mobile.svg);
    }
}
@font-face {
  font-family: 'sb-icons';
  src: url("//cdn.shopify.com/s/files/1/0060/7895/5610/t/5/assets/sb-icons.eot?v=10859849631247340556"); }

@font-face {
  font-family: 'sb-icons';
  src: url("data:application/x-font-ttf;charset=utf-8;base64,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") format("truetype");
  font-weight: normal;
  font-style: normal; }
.footer {
    //  position: fixed;
//   height: 54px; 
  align-content: start;
  width:100%;
  flex: 0 1 auto;
  padding-top:60px;
  padding-bottom: 18px;
  padding-left: 30px;
}

.snotify {
    width: auto !important;
}
.icon {
    font-family: sb-icons!important;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    vertical-align: middle;
}
.icon--facebook:before {
    content: "\e90c";
}
.icon--twitter:before {
    content: "\e909";
}
.icon--instagram:before {
    content: "\e90b";
}
.icon--youtube:before {
    content: "\e933";
}
.fontface .icon:before {
    display: inline-block;
}
.card-container {
  background-color: #FFFFFF;
  border-radius: 0px;
  border: 1px solid #e4e4e4;
  padding: 1rem 1rem 1rem 1rem;
  margin: 0px 20px 20px 20px;
  -webkit-box-shadow: 0px 0px 16px -8px rgba(0,0,0,0.15);
  -moz-box-shadow: 0px 0px 16px -8px rgba(0,0,0,0.15);
  box-shadow: 0px 0px 16px -8px rgba(0,0,0,0.15);
}

.child-view {
  transition: all .5s cubic-bezier(.55,0,.1,1);
  left: 0;
  width: 100%;
}

.slide-left-enter, .slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}
.slide-left-leave-active, .slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
.footerColumn{
  line-height: 2;
}
.footerEnd{
  -webkit-text-size-adjust: 100%;
  line-height: 2;
  font-weight: 700;
  font-style: normal;
  visibility: visible;
  color: #fffc;
  box-sizing: inherit;
  position: relative;
  display: block;
  font-size: 12px;
}
.footerHead, .footerHead a {
  -webkit-text-size-adjust: 100%;
  visibility: visible;
  list-style: none;
  font-family: Montserrat,sans-serif;
  font-weight: 700;
  font-style: normal;
  letter-spacing: 1px;
  line-height: 1.7;
  box-sizing: inherit;
  background-color: transparent;
  text-decoration: none;
  transition: all .3s ease-in-out;
  color: #FFF;
  font-size: 16px;
  margin-bottom: 12px;
}
.footerSMGroup{
  display:flex; 
  margin:3px 6px 0 0;
  padding-bottom:8px;
}
.footerSMGroup > * {
    margin-left: 8px;
}
.footerSMGroup > *:first-child {
    margin-left: 0px;
}
.footerSM{
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  border-radius: 50%; 
  border: 1px solid rgba(255,255,255,.8);
  width: 38px;
  height: 38px;
}
.footerText {
  margin-bottom: 3px;
  font-weight: 700;
  font-size: 15px;
  color: #fffc;
}
.footerHead a:hover, .footerHead a:visited, .footerHead a:active{
  opacity: .7;
}
.footerLink{
  color: #fffc;
}
.footerLink:hover, .footer:visited, .footer:active{
  color: #FFF;
}
.footerLogo{
  max-height:105px;
}
html, body {
   height: 95%;
}
</style>
